
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Button, Grid } from "@mui/material";
import { useEffect } from "react";
import AdaptacionesCurriculares from "../../components/Form/Fields/AdaptacionesCurriculares";
import Caracterizacion from "../../components/Form/Fields/Caracterizacion";
import CondicionesContexto from "../../components/Form/Fields/CondicionesContexto";
import TemaClase from "../../components/Form/Fields/TemaClase";
import GuiaAprendizajeCardImg from "../../components/UmmIApps/Cards/GuiaAprendizajeCardImg.png";
import { useActividadesContext } from "../../components/UmmIACategories/Hook/useActividades";
import UmmiaAppsLayout from "../../components/UmmIACategories/Layout/UmmiaAppsLayout";
import CurriculumTabs from "../../components/CurriculumTabs/CurriculumTabs";
import { useAuthContext } from "../../hooks/Auth";
import { isSendButtonDisabled } from "../../config/sendButtonRules";

const GuiaAprendizajePage = () => {

  const {
    nivelId,
    nivelTPId,
    materiaId,
    asignaturaTPId,
    promptData,
    toggleCamposAvanzados,
    mostrarCamposAvanzados,
    handleBack,
    setTextoInicial,
    handleInitialPromptData,
    handleNivelChange,
    handleNivelTPChange,
    handleAsignaturaTPChangeLocal,
    clearTP,
    handleAsignaturaChangeLocal,
    setPromptData,
  } = useActividadesContext();

  const { user } = useAuthContext();

  const isButtonDisabled =  isSendButtonDisabled("guia_aprendizaje", { promptData });;
  const colorIconBack = "#BA4534";

  useEffect(() => {
    const init = {
      caracterizacion: "",
      condiciones_contexto: "",
      tema: "",
      adaptaciones_curriculares: "",
      temperatura: 0.1,
      idioma: "español"
    };
    handleInitialPromptData(init, "guia_aprendizaje");
    setTextoInicial(
      "A continuación te propongo 12 posibles preguntas y actividades para incluir en una guía de aprendizaje. Selecciona las que mejor se ajusten a tus preferencias y contexto y proponlas a tus estudiantes. Ajusta los parámetros en 'Mostrar campos', genera una nueva versión con 'Volver a generar' o personaliza el contenido con 'Editar'. Si prefieres trabajar en otra plataforma, usa 'Copiar' para llevar el texto donde desees."
    );
  }, []);

  useEffect(() =>{
    console.log("ESTA ES LA INFORMACIÓN DEL USUARIO: ", user);
    
  }, [])

  return (
    <UmmiaAppsLayout
      onBack={handleBack}
      imageSrc={GuiaAprendizajeCardImg}
      backgroundColorImage={
        "linear-gradient(180deg, #FFFFFF 0%, #E3B5AE 100%, #C86A5D 100%)"
      }
      title="Guía de aprendizaje l"
      description="Genera guías de trabajo con preguntas de elaboración y reflexión del contenido"
      titleColor="#BA4534"
      isButtonDisabled={isButtonDisabled}
      colorIconBack={colorIconBack}
    >
      <Grid container spacing={2}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            
              <CurriculumTabs
                nivelId={nivelId}
                materiaId={materiaId}
                nivelTPId={nivelTPId}
                asignaturaTPId={asignaturaTPId}
                handleNivelChange={handleNivelChange}
                handleNivelTPChange={handleNivelTPChange}
                handleAsignaturaChangeLocal={handleAsignaturaChangeLocal}
                handleAsignaturaTPChangeLocal={handleAsignaturaTPChangeLocal}
                clearTP={clearTP}
                promptData={promptData}
                setPromptData={setPromptData}
              />
            
          </Grid>
        </Grid>
        <Grid item xs={12} lg={12} display="flex" flexDirection="row">
          <TemaClase />
        </Grid>

        <Grid item xs={12} container justifyContent="center" sx={{ mb: 3 }}>
          <Button
            variant="text"
            sx={{ color: "#336B87" }}
            onClick={toggleCamposAvanzados}
            endIcon={
              mostrarCamposAvanzados ? <ExpandLessIcon /> : <ExpandMoreIcon />
            }
          >
            {mostrarCamposAvanzados
              ? "Ocultar opciones avanzadas"
              : "Mostrar opciones avanzadas (opcional)"}
          </Button>
        </Grid>
        {/* Campos avanzados */}
        {mostrarCamposAvanzados && (
          <>
            <Grid item xs={12} lg={12} display="flex" flexDirection="row">
              <CondicionesContexto />
            </Grid>

            <Grid item xs={12} lg={12} display="flex" flexDirection="row">
              <Caracterizacion />
            </Grid>

            <Grid item xs={12} lg={12} display="flex" flexDirection="row">
              <AdaptacionesCurriculares />
            </Grid>
          </>
        )}
      </Grid>
    </UmmiaAppsLayout>
  );
};

export default GuiaAprendizajePage;
